export default class AssociateWorkTypeWithEntityError extends Error {

}
